import { defineCustomElement } from 'vue';
import MarqueeComponent from './Marquee.vue';

// Convert Vue component to a web component
const HolidayMarquee = defineCustomElement(MarqueeComponent);

// Define the custom element tag
customElements.define('holiday-marquee', HolidayMarquee);